import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

import useTranslates from 'utils/translate';

import Sport from 'components/common/icons/Sport';
import CasinoIcon from 'components/common/svg/Casino';
import LiveCasinoIcon from 'components/common/svg/LiveCasino';
import SportLiveIcon from 'components/common/icons/SportLive';
import MobileNavigation from 'components/sections/Navigation/Mobile';

import sx from './styles';

const MobileFooter: FC<{ url?: string }> = ({ url }) => {
  const { translate } = useTranslates();

  const isLiveUrls = url.includes('live');

  return (
    <MobileNavigation
      headerVisible={false}
      footerNavigation={
        <>
          <Link to="?tab=live">
            <Box sx={sx.navButton({ selected: isLiveUrls })}>
              <SportLiveIcon sx={{ fontSize: 24 }} />
              <Typography>{translate(`live`)}</Typography>
            </Box>
          </Link>
          <Link to="?tab=">
            <Box sx={sx.navButton({ selected: !isLiveUrls })}>
              <Sport sx={{ fontSize: 24 }} />
              <Typography>{translate('sport')}</Typography>
            </Box>
          </Link>
          <Link to="/games/slots">
            <Box sx={sx.navButton({ selected: false })}>
              <CasinoIcon />
              <Typography>{translate('casino')}</Typography>
            </Box>
          </Link>
          <Link to="/games/live_casino">
            <Box sx={sx.navButton({ selected: false })}>
              <LiveCasinoIcon />
              <Typography>{translate('live_casino')}</Typography>
            </Box>
          </Link>
        </>
      }
    />
  );
};

export default MobileFooter;
